import { toast } from "react-toastify";

/**
 * Exporta o fluxo atual para um arquivo JSON baixável.
 */
export const exportFlowToJson = (flow) => {
  if (!flow) return;

  const exportData = {
    version: 1,
    name: flow.name || "Fluxo",
    nodes: flow.nodes || [],
    edges: flow.edges || [],
    exportedAt: new Date().toISOString(),
  };

  const jsonString = JSON.stringify(exportData, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);
  
  const link = document.createElement("a");
  link.href = url;
  const fileName = `${(flow.name || "fluxo").toLowerCase().replace(/[^a-z0-9]/gi, "_")}_export.json`;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);

  toast.success(`Fluxo "${flow.name || "Fluxo"}" exportado com sucesso.`);
};

/**
 * Re-mapeia inteligentemente os IDs das entidades de uma empresa (Filas, Usuários, Etiquetas, Conexões)
 * ao importar um JSON criado em outro usuário ou empresa.
 */
export const processImportedFlowData = (importedJson, contextData = {}) => {
  if (!importedJson || typeof importedJson !== "object") {
    throw new Error("Arquivo JSON inválido.");
  }

  const nodes = Array.isArray(importedJson.nodes) ? importedJson.nodes : [];
  const edges = Array.isArray(importedJson.edges) ? importedJson.edges : [];
  const name = (importedJson.name || "Fluxo Importado").trim();

  const {
    queues = [],
    users = [],
    tags = [],
    whatsapps = [],
  } = contextData;

  // Processa cada nó adaptando IDs para a empresa de destino
  const processedNodes = nodes.map((node) => {
    if (!node || typeof node !== "object") return node;

    const data = { ...(node.data || {}) };

    // 1. Re-mapeamento de Fila (transferQueue)
    if (node.type === "transferQueue" || data.queueName || data.queueId) {
      if (data.queueName) {
        const queueMatch = queues.find(
          (q) => q.name?.trim().toLowerCase() === data.queueName.trim().toLowerCase()
        );
        if (queueMatch) {
          data.queueId = String(queueMatch.id);
          data.queueName = queueMatch.name;
        } else {
          // Se a fila não existir no novo usuário, limpa o ID órfão
          data.queueId = "";
        }
      }
    }

    // 2. Re-mapeamento de Atendente (assignUser)
    if (node.type === "assignUser" || data.userName || data.userId) {
      if (data.userName) {
        const userMatch = users.find(
          (u) => u.name?.trim().toLowerCase() === data.userName.trim().toLowerCase()
        );
        if (userMatch) {
          data.userId = String(userMatch.id);
          data.userName = userMatch.name;
        } else {
          data.userId = "";
        }
      }
    }

    // 3. Re-mapeamento de Etiqueta (addTag)
    if (node.type === "addTag" || data.tagName || data.tagId) {
      if (data.tagName) {
        const tagMatch = tags.find(
          (t) => t.name?.trim().toLowerCase() === data.tagName.trim().toLowerCase()
        );
        if (tagMatch) {
          data.tagId = String(tagMatch.id);
          data.tagName = tagMatch.name;
        } else {
          data.tagId = "";
        }
      }
    }

    // 4. Re-mapeamento de Conexão WhatsApp (sendMessage)
    if (node.type === "sendMessage" && (data.whatsappName || data.whatsappId)) {
      if (data.whatsappName) {
        const waMatch = whatsapps.find(
          (w) => w.name?.trim().toLowerCase() === data.whatsappName.trim().toLowerCase()
        );
        if (waMatch) {
          data.whatsappId = String(waMatch.id);
        } else {
          data.whatsappId = "";
        }
      } else {
        const defaultWa = whatsapps.find((w) => w.isDefault) || whatsapps[0];
        if (defaultWa) {
          data.whatsappId = String(defaultWa.id);
          data.whatsappName = defaultWa.name;
        }
      }
    }

    return {
      ...node,
      data,
    };
  });

  return {
    name: `${name} (Importado)`,
    nodes: processedNodes,
    edges,
  };
};
